import { Inject, Injectable } from '@angular/core';
import { TRANSLATOR, Translator } from '@miq/utils';
import { FloorClass } from '../../models/floor.class';
import { LocalizationOptions } from '../../models';
import { FloorContainer } from './floor-container.model';

export interface FloorClassAdapterOptions {
  localizationConfigs: LocalizationOptions;
}

export interface FloorClassAdapterResponse {
  floors: FloorClass[];
  unaccountedSpaceTotal: number;
}

@Injectable()
export class FloorClassAdapter {
  constructor(@Inject(TRANSLATOR) private translationService: Translator) {}

  public adapt(floorData: FloorContainer, localizationConfigs: LocalizationOptions): FloorClass[] {
    const { totalNumberOfFloors, totalNumberOfFloorsUnderground, floors } = floorData;
    const incomingFloors = floors.map(edpFloorSpace => {
      // * Sometime by some reason, floors have space size as string instead of number or null displaying an error when updating a record...
      let floor_size = !edpFloorSpace.floor_size ? null : edpFloorSpace.floor_size;

      return FloorClass.fromEDPFloorSpaceInfo(
        { ...edpFloorSpace, floor_size },
        {
          localization: localizationConfigs,
          translationService: this.translationService as never,
        }
      );
    });
    // Floor data with positive indexes
    const startFloorsFrom = FloorClass.getStartingFloorIndex(localizationConfigs.localeId);
    const indexedFloorData = FloorClass.generateAboveGroundFloors(totalNumberOfFloors, incomingFloors, startFloorsFrom);

    // Floor data with negative indexes and greater than -90 (parking floors)
    const parkingFloorData = FloorClass.generateUndergroundFloors(totalNumberOfFloorsUnderground, incomingFloors);

    // Floor data with negative indexes less than -90 (un-indexed data)
    const unIndexedFloorData = FloorClass.getInvalidIndexed(incomingFloors);

    const nextFloorData = [...unIndexedFloorData, ...parkingFloorData, ...indexedFloorData].reverse();

    // NOTE: calc and set of sumUnaccountedSpace moved to stacking plan service
    return nextFloorData;
  }
}
